// Modèle pour le suivi des mises à jour

// Structure initiale pour une nouvelle mise à jour
// Types de mise à jour disponibles
export const updateTypes = ['Production', 'Qualification'];

export const getEmptyUpdate = () => ({
  id: Date.now(), // Un ID unique basé sur le timestamp
  date: new Date().toISOString(),
  title: '',
  description: '',
  ticketUrl: '', // URL du ticket Jira/Taiga
  updateType: 'Production', // Type de mise à jour : Production ou Qualification
  status: 'completed', // 'completed', 'cancelled', 'partial'
  statusReason: '', // Raison de l'annulation ou de réalisation partielle
  // Section "MISE À JOUR"
  update: {
    dbSchemaUpdated: false,
    servicesRestarted: false,
    mobileAppUpdated: false,
    buildsUpdated: false,
    mobileAppCreated: false,
    internalTestsCompleted: false,
    appDeployedToStores: false,
    notes: ''
  },
  // Section "GENERAL"
  general: {
    production: {
      secureClientConnection: false,
      softwareComponentsRecovery: false,
      softwareDependenciesRecovery: false,
      notes: ''
    },
    verification: {
      carePortalDisplay: false,
      carePortalLogin: false,
      patientSearch: false,
      pairingSheetGeneration: false,
      patientPortalDisplay: false,
      patientPortalLogin: false,
      notes: ''
    }
  },
  // Section "COMMITS"
  commits: {
    manager: '',
    marshallerFrontal: '',
    marshallerInterop: '',
    patientApp: '',
    datamodel: '',
    notes: ''
  },
  // Pour ajouter des notes supplémentaires
  additionalNotes: ''
});
